let screenOrientation = getScreenOrientation();
let firstLoad = true;

window.theme.readHeights = function () {
  const h = {};
  h.windowHeight = Math.min(window.screen.height, window.innerHeight);
  h.footerHeight = getHeight('[data-section-type*="footer"]');
  h.headerHeight = getHeight('[data-header-height]');
  h.mobileCollectionBlock = getHeight('.mobile-menu__block--collection');
  h.mobileSearchBlock = getHeight('.mobile-menu__block-search-wrapper');
  h.stickyHeaderHeight = document.querySelector('[data-header-sticky]') ? h.headerHeight : 0;
  h.collectionNavHeight = getHeight('[data-collection-nav]');
  h.logoHeight = getFooterLogoWithPadding();
  h.announcementBarHeight = getHeight('[data-announcement-bar-height]');

  return h;
};

function setVars() {
  const {windowHeight, headerHeight, mobileCollectionBlock, mobileSearchBlock, announcementBarHeight, logoHeight, footerHeight, collectionNavHeight} = window.theme.readHeights();
  const currentScreenOrientation = getScreenOrientation();

  if (!firstLoad || currentScreenOrientation !== screenOrientation || window.innerWidth > window.theme.sizes.mobile) {
    // Only update the heights on screen orientation change or larger than mobile devices
    document.documentElement.style.setProperty('--full-height', `${windowHeight}px`);
    document.documentElement.style.setProperty('--three-quarters', `${windowHeight * (3 / 4)}px`);
    document.documentElement.style.setProperty('--two-thirds', `${windowHeight * (2 / 3)}px`);
    document.documentElement.style.setProperty('--one-half', `${windowHeight / 2}px`);
    document.documentElement.style.setProperty('--one-third', `${windowHeight / 3}px`);

    // Update the screen orientation state
    screenOrientation = currentScreenOrientation;
    firstLoad = false;
  }

  let announcementBarSlider = document.querySelectorAll('[data-announcement-wrapper] swiper-slide');
  let maxAnnouncementBarHeight = getHeight('[data-announcement-bar-height]');
  announcementBarSlider.forEach((slide) => {
    if (slide.offsetHeight > maxAnnouncementBarHeight) {
      maxAnnouncementBarHeight = slide.offsetHeight;
    }
  })

  let articleNavBar = document.querySelector('.article-navigation');
  if (articleNavBar) {
    let articleNavBarHeight = articleNavBar.offsetHeight;
    let elHeroFallback = document.querySelector('.article-hero__fallback');
    let articleHero = document.querySelector('.article-hero');
    if (elHeroFallback) {
      let currentPaddingDesktop = getComputedStyle(elHeroFallback).getPropertyValue('--padding-top').trim();
      let currentPaddingMobile = getComputedStyle(elHeroFallback).getPropertyValue('--padding-top-mobile').trim();
      let currentPxDesktop = parseInt(currentPaddingDesktop) || 0;
      let currentPxMobile = parseInt(currentPaddingMobile) || 0;
      let newPxDesktop = currentPxDesktop + articleNavBarHeight;
      let newPxMobile = currentPxMobile + articleNavBarHeight;
      setTimeout(() => {
        elHeroFallback.style.setProperty('--padding-top', newPxDesktop + 'px');
        elHeroFallback.style.setProperty('--padding-top-mobile', newPxMobile + 'px');
      }, 0)
    }

    if (articleHero) {
      setTimeout(() => {
        articleHero.style.marginTop = articleNavBarHeight + 'px';
      }, 0)
    }
  }

  document.documentElement.style.setProperty('--collection-nav-height', `${collectionNavHeight}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--mobile-collection-block', `-${mobileCollectionBlock}px`);
  document.documentElement.style.setProperty('--mobile-search-block', `${mobileSearchBlock}px`);
  document.documentElement.style.setProperty('--announcement-bar-height', `${maxAnnouncementBarHeight}px`);
  document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
  document.documentElement.style.setProperty('--content-full', `${windowHeight - headerHeight - logoHeight / 2}px`);
  document.documentElement.style.setProperty('--content-min', `${windowHeight - headerHeight - footerHeight}px`);
}

function getScreenOrientation() {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return 'portrait';
  }

  if (window.matchMedia('(orientation: landscape)').matches) {
    return 'landscape';
  }
}

function getHeight(selector) {
  const el = document.querySelector(selector);
  if (el) {
    return el.offsetHeight;
  } else {
    return 0;
  }
}

function getFooterLogoWithPadding() {
  const height = getHeight('[data-footer-logo]');
  if (height > 0) {
    return height + 20;
  } else {
    return 0;
  }
}

setVars();

window.addEventListener('DOMContentLoaded', setVars);
document.addEventListener('theme:resize', setVars);
document.addEventListener('shopify:section:load', setVars);
